interface TwilioGlobal {
    Twilio?: {
        Flex?: unknown;
    };
    __TWILIO_FLEX_SDK__?: {
        appType?: string;
    };
}

export const getOrigin = () => {
    const global = globalThis as typeof globalThis & TwilioGlobal;
    if (global.Twilio?.Flex) {
        return "flexui";
    }
    if (global.__TWILIO_FLEX_SDK__?.appType === "flex-mobile") {
        return "mobile";
    }
    return "headless";
};
